import React, { Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth,scrollToTop } from "../Helpers/SettingHelper";
import { apiUrl, mediaUrl} from'../Config/Config';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };

class NotificationTypeEdit extends Component {

	constructor(props)
	{
		CheckAuth();
		super(props);	
	    const editId = (typeof this.props.params.ID === 'undefined') ? '' : this.props.params.ID;
		this.state = {
            editId: editId,
			Loading:false,
			selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'active',
			selectedNotificationType : { value: 'common', label: 'Common' },
			selectedNotTypevalue:"common",
			old_noti_img:'',
			icon:'',
		};
		
			
		console.log(this.state, 'ressss0');
		// console.log(res.data.membershiplist, 'resssss');

		
		
		this.handleInputChange = this.handleInputChange.bind(this);
	    this.handleChange = this.handleChange.bind(this);
	    this.onChangeHandler = this.onChangeHandler.bind(this);
		// this.onEditorChange = this.onEditorChange.bind( this );
    }



	emojiToEntity(str) {
		return str.replace(/\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu, emoji => {
			return `&#${emoji.codePointAt(0)};`;
		});
	}

   	onChangeHandler=event=>{
		let reader = new FileReader();
		const file = event.target.files[0];
		const extension = file.name.split('.').pop();
		reader.onloadend = () => {
			this.setState({
				icon_name: file.name,
				icon_preview: reader.result,
				icon: file,
				icon_fileExtension:extension,			
			});
		};
		reader.readAsDataURL(file);
	} 
    handleChange = (r,selOption) => {
       
		if(r == 'status'){
			this.setState({selectedOption:selOption})
			this.setState({  selectedvalue : selOption.value});
		}
		else if(r == 'selectedNotificationType'){
			this.setState({ selectedNotificationType: selOption });
			this.setState({ selectedNotTypevalue: selOption.value });
		}
		console.log(selOption.value, 'sdfg')
 	};

   	handleInputChange(event) {
		const {name, value} = event.target;   
		 const numberFields = ["walletAmt", "earnPoints", "extraBonusPoints"];

		// If field should be numeric → validate
		if (numberFields.includes(name)) {
			// Allow only numbers (you can tweak regex if needed)
			if (!/^\d*$/.test(value)) {
			return; 
			}
		}

		this.setState({
			[name]: value
		});	
    }

	componentDidMount() {
		
		var qs = require('qs');
		var editId = this.state.editId;

		axios.get(apiUrl+"notificationtype/listdetail?id="+editId).then(res => {
			console.log(res, 'res000');
			this.setState({
				selectedNotTypevalue :lang.common.notification_type.find(
											  item => item.value === res.data.listdetail.title
										  )?.value,
				selectedNotificationType:lang.common.notification_type.find(
											  item => item.value === res.data.listdetail.title
										  )
				});
			if(res.data.listdetail.status === 'A'){
				this.setState({selectedOption:{value: 'active', label: 'Active'}});
			}else{
				this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
			}
  
			
			if(res.data.listdetail.image !== null){
				this.setState({old_noti_img:res.data.listdetail.image});
			}

		document.title = PageTitle('Notification Type Edit');
        }); 
	}
	

	Capitalize = (str) => {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}

	
    handleFormSubmit = () => {
		if(this.validateForm()){ 
			this.setState({Loading:true});
			const config = {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
				};
			const formPayload = this.state;
			var qs = require('qs');
			var status = '';
            var notificationtype ='';
			if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
				status =formPayload.selectedOption.value;
			}else{
				status = formPayload.selectedvalue;
			}

			 if (formPayload.selectedNotTypevalue === "") {
				notificationtype = formPayload.selectedNotificationType.value;
			} else {
				notificationtype = formPayload.selectedNotTypevalue;
			}

			

			var postObject = {
				editId:this.state.editId,
				admin_id : localStorage.getItem("admin_id"),
				title: notificationtype,
				status: status,
				old_noti_img:formPayload.old_noti_img,
			
			};
			let formData = new FormData();
			for(let k in postObject) {
			formData.append(k, postObject[k]);
			}		       
			var icondata = formPayload.icon;
			formData.append('file',icondata)
			//axios.post(apiUrl+"membership/edit",qs.stringify(postObject) ).then(res => {
			axios.post(apiUrl+"notificationtype/edit",formData).then(res => {
				if(res.data.status === "success"){	
					this.setState({Loading:false});
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');							
					setTimeout(
						function() {
							$('.success_message').html(this.props.navigate('/notificationtype'));
						}
					.bind(this),
					3000
					);
				}else{
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					
					setTimeout(
					function() {
						$('.success_message').html('');
					}
					.bind(this),
					3000
					);
					this.setState({Loading:false});
				}
			});
		}
	}

	validateForm() {
		//const {admin_company_name,admin_fname} = this.state;
		 const {selectedNotTypevalue} = this.state;
		let errors = {};
      	let formIsValid = true;
		const nameRegex = /^[A-Za-z\s.]+$/;

		if(selectedNotTypevalue == ''){
				errors++;
				$(".errortitle").html(
				'<span class="errorspan">Please fill the field</span>',
				);
			}
			
		  
			this.setState({
			errors: errors,
			});
			return formIsValid;
    }

  render() {
	
  	const {selectedOption,selectedNotificationType} = this.state;
		
		let loaderimg = '';
		var	preview = (this.state.icon_preview) ? 
			<img className="img_class" src={this.state.icon_preview} alt="" /> :
			<img className="img_class" src={mediaUrl+'notification_icons/'+this.state.old_noti_img} alt="" />
			;

  	
return (
	<div className="wrapper"> 

		<Header />
		<MenuSidebar currentpage="notificationtype" currentTab="common" />  
		<div className="content">	
			<div className="content-wrapper">
				<div class="content-wrapper-before"></div>
				<div className="form-wrapper leaa-admin-head card">
					<div className="success_message"></div>
					<div>
						<a class="primary-btn" href="/notificationtype">Back</a>
					</div>
					<div className="title">
						<h4>Edit Notification Type</h4>
					</div>
					<form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} encType="multipart/form-data">
						<div className="form-row">
							<div className="form-left">
                                 <div className="form-group">
									<label>
										Notification Type
										<span class="required" style={{ color: "red" }}>
										*{" "}
										</span>
									</label>
									{/* <input
										type="text"
										name="title"
										onChange={this.handleInputChange}
										className="form-control"
										value={this.state.title}
									/> */}
									<Select
									name="title"
									value={
									selectedNotificationType
										? selectedNotificationType
										:  ""
									}
									options={lang.common.notification_type}
									isSearchable={false}
									onChange={this.handleChange.bind(this, "selectedNotificationType")}
								/>
                     
								<div className="errortitle"></div>
								</div>
								  <div className="form-group">
                      <label>
                        Status
                        <span class="required" style={{ color: "red" }}>
                          *
                        </span>
                      </label>
                      <Select
                        name="status"
                        value={
                          selectedOption
                            ? selectedOption
                            : { value: "active", label: "Active" }
                        }
                        options={lang.common.status_option}
                        isSearchable={false}
                        onChange={this.handleChange.bind(this, "status")}
                      />
                    </div>
                  </div>

                  <div className="form-right">
                   
                    

					 <div className="form-group">
                      <label>Image (jpeg,jpg,png,svg)</label>
                      <div className="choose-file">
                        {this.state.isHidden && (
                          <div className="image_success"></div>
                        )}
                        <span className="profile_btn">
                          <input
                            type="file"
                            name="file"
                            onChange={this.onChangeHandler}
                          />
                        </span>
                      </div>
                      {preview}
                      <div className="errorimage"></div>
                    </div>
                    
                    {/* <div className="form-group">
                      <label>Description</label>
                           <CKEditor
                        editor={ClassicEditor}
                        data={this.state.description || ""}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                        }}
                        name="description"
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          this.onEditorChange("description", data);
                        }}
                      />
                      
                      <div className="errordescription"></div>
                    </div> */}
                  
                  </div>	
						</div>		

						<div className="btn-group export">	
							<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true? <span>updating</span>:<span>Submit</span>}
							</button>
						</div>
					</form>
				</div>				
			</div>	
		</div>
	</div>
	);
}
}


// const mapStateTopProps = (state) => {
//   return {
//     membershipdetails: state.membershipdetails,
//     membershipedit: state.membershipedit
//   }
// }

// const mapDispatchToProps = (dispatch) => {
//   return {
//     getCategoryDetailList: (memId) =>{
//        dispatch({ type: GET_CATEGORYDETAILLIST,memId });
//     },
//     getEditCategory: (formPayload) =>{
//        dispatch({ type: GET_EDITCATEGORY, formPayload});
//     }
//   }
// }
export default (withRouter(NotificationTypeEdit));